import { render, staticRenderFns } from "./MainContentWithAd.vue?vue&type=template&id=29a308a9&"
import script from "./MainContentWithAd.vue?vue&type=script&lang=ts&"
export * from "./MainContentWithAd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports